import { apiUrl } from '../config/apiBase';

export class ApiError extends Error {
  constructor(message, status, data) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
  }
}

function parseErrorMessage(data, fallback) {
  if (!data) return fallback;
  if (typeof data.message === 'string') return data.message;
  if (Array.isArray(data.message)) return data.message.join(', ');
  return fallback;
}

let refreshPromise = null;

function isPlatformAuthPath(path) {
  return path.includes('/api/platform/auth/');
}

async function refreshPlatformSession() {
  if (!refreshPromise) {
    refreshPromise = fetch(apiUrl('/api/platform/auth/refresh'), {
      method: 'POST',
      credentials: 'include',
    })
      .then((response) => response.ok)
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
}

async function executeFetch(path, options) {
  const { errorMessage = 'Request failed', parseJson = true, headers, body, ...fetchOptions } = options;
  const requestHeaders = { ...headers };

  if (body !== undefined && !(body instanceof FormData)) {
    requestHeaders['Content-Type'] = 'application/json';
  }

  const response = await fetch(apiUrl(path), {
    credentials: 'include',
    ...fetchOptions,
    headers: requestHeaders,
    body: body !== undefined && !(body instanceof FormData) && typeof body !== 'string' ? JSON.stringify(body) : body,
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    const message = parseErrorMessage(data, errorMessage);
    throw new ApiError(message, response.status, data);
  }

  if (!parseJson || response.status === 204) {
    return null;
  }

  const contentType = response.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    return null;
  }

  return response.json();
}

export async function platformApiFetch(path, options = {}) {
  const { _retry = false, method, ...restOptions } = options;

  try {
    return await executeFetch(path, { method, ...restOptions });
  } catch (error) {
    if (error instanceof ApiError && error.status === 401 && !isPlatformAuthPath(path)) {
      if (_retry) {
        throw error;
      }
      const refreshed = await refreshPlatformSession();
      if (refreshed) {
        return platformApiFetch(path, { method, ...restOptions, _retry: true });
      }
    }
    throw error;
  }
}
